var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.331,
    height: 16.285,
    viewBox: "0 0 27.331 16.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffffff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.645,0H1.9A1.9,1.9,0,0,0,0,1.9v12.49a1.9,1.9,0,0,0,1.9,1.9H17.645a1.9,1.9,0,0,0,1.9-1.9V1.9A1.9,1.9,0,0,0,17.645,0Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M328.906,40.7l6.522,3.561V31.98l-6.522,3.561Zm0,0",
    transform: "translate(-308.098 -29.957)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceWhite);
export default __webpack_public_path__ + "static/media/device-white.accffec7182c0e8788de4bf56a18f38e.svg";
export { ForwardRef as ReactComponent };